var O = /* @__PURE__ */ ((L) => (L.CLOUD = "CLOUD", L.CRAWLING_MODULE = "CRAWLING_MODULE", L.ON_PREM = "ON_PREM", L.PUSH = "PUSH", L))(O || {});
export {
  O as SourceCategory
};
//# sourceMappingURL=Sources.js.map
